import YtTable from './table'

export default {
  install: (Vue) => {
    Vue.component('yt-table', YtTable)
  }
}